<template lang="pug">
.k-user-modal-share
  k-card-modal(
    :value="value"
    v-bind="$data.$_attrs"
    v-on="$listeners"
    max-width="400"
  )
    .text-xs-center
      .title--regular.font-weight-bold.brand-pink--text.mb-10 Share Link
    v-divider.my-6
    k-loader(:value="loadingKintellCardShortLink")
      a(:href="mailShare").paragraph.brand-dark-aqua--text.font-weight-bold.unstyled--link
        k-icon(color="rgb(72, 72, 72)").mr-3 mail
        | Email
      v-divider.my-6
      k-share(:link="shareLink" show-copied :show-toast="false")
        a.paragraph.brand-dark-aqua--text.font-weight-bold
          k-icon(color="rgb(72, 72, 72)").mr-3 copy
          | Copy Link
      v-divider.my-6
      a(@click="showEmbedCode = true").paragraph.brand-dark-aqua--text.font-weight-bold
        k-icon(color="rgb(72, 72, 72)").mr-3 code
        | Embed
      template(v-if="showEmbedCode")
        .paragraph--small.mt-2 Paste the following HTML into your website to embed your Kintell card. #[nuxt-link(to="/get-in-touch") Get in touch] if you need any help :)
        textarea(
          :value="embedCode"
          @click="copyEmbedCodeToClipboard"
          readonly
          ref="codeSnippet"
        ).mt-3.k-user-modal-share__code-snippet
</template>

<script>
import { UsesAuthenticatedUser, BindsAttrs } from '@/mixins'
import queryString from 'query-string'

export default {
  mixins: [ UsesAuthenticatedUser, BindsAttrs ],
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    text: {
      type: String,
      required: false,
      default: '',
    },
    kintellCard: {
      type: Object,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      excitedPerson: require('~images/excited-person.svg'),
      showEmbedCode: false,
      loadingKintellCardShortLink: false
    }
  },
  computed: {
    mailShare () {
      const query = queryString.stringify({
        subject: this.title,
        body: this.text + ' ' + this.shareLink,
      })
      return 'mailto:?' + query
    },
    embedCode () {
      return '<iframe style="box-shadow: 0 15px 35px 0 rgba(50, 50, 93, 0.1);" width="300" height="350"  frameborder="0" scrolling="no" src="' + this.embedLink + '/embed' + '"></iframe>'
    },
    shareLink () {
      // If the kintell card has not been loaded yet then exit out
      if (!this.kintellCard) {
        return
      }

      return this.kintellCard.shortLink && this.isOwnCard ? this.kintellCard.shortLink : window.location.origin + this.kintellCard.link
    },
    embedLink () {
      // If the kintell card has not been loaded yet then exit out
      if (!this.kintellCard) {
        return
      }
      // using id in case user changes their kintell card or name (unlikely)
      return window.location.origin + '/advisors/' + this.kintellCard.createdBy + '/' + this.kintellCard.id
    },
    isOwnCard () {
      return this.authenticatedUser && this.authenticatedUser.id === this.kintellCard.createdBy
    }
  },
  watch: {
    value (val) {
      if (val && this.kintellCard && !this.kintellCard.shortLink && this.isOwnCard) {
        this.createShortLink()
      }
    }
  },
  methods: {
    copyEmbedCodeToClipboard () {
      this.$refs.codeSnippet.select()
      document.execCommand('copy')
      this.$toast.success('Embed code snippet copied')
    },
    async createShortLink () {
      this.loadingKintellCardShortLink = true
      await this.kintellCard.fetchShortLink()
      this.loadingKintellCardShortLink = false
    }
  }
}
</script>

<style lang="scss" scoped>
.k-user-modal-share {
  &__code-snippet {
    border: 1px solid var(--v-brand-dark-blue-base);
    border-radius: 4px;
    box-sizing: border-box;
    color: var(--v-brand-grey-base);
    padding: 5px;
    width: 100%;
  }
}
</style>
